(function () {
  const siteHeader = document.querySelector(".site-header");

  function handleScroll() {
    if (window.scrollY > 100) {
      siteHeader.classList.add("scrolled");
    } else {
      siteHeader.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", handleScroll);

  // Initial check on page load
  handleScroll();

  const menuItems = document.querySelectorAll(".menu-item-has-children > a");

  if (menuItems) {
    menuItems.forEach((link) => {
      link.addEventListener("click", function (e) {
        const parentLi = this.parentElement;

        // Only apply toggle below breakpoint 1280px
        if (window.innerWidth <= 1280) {
          // e.preventDefault();
          parentLi.classList.toggle("open");
        }
      });
    });
  }

  // Get Involved Modal
  const openGetInvolved = document.querySelectorAll(
    ".open-get-involved-button"
  );
  const closeGetInvolved = document.querySelector(".get-involved-modal__close");
  const modal = document.querySelector(".get-involved-modal");
  const body = document.querySelector("body");

  if (openGetInvolved.length === 0 || !modal || !closeGetInvolved) {
    return;
  }

  openGetInvolved.forEach((openGI) => {
    openGI.addEventListener("click", function (e) {
      e.preventDefault();
      modal.classList.add("active");
      body.style.overflow = "hidden";
    });
  });

  closeGetInvolved.addEventListener("click", function (e) {
    e.preventDefault();
    modal.classList.remove("active");
    body.style.overflow = "auto";
  });

  // SEARCH Modal
  const openSearchModal = document.querySelector(".header-buttons__search");
  const closeSearchModal = document.querySelector(".search-modal__close");
  const searchModal = document.querySelector(".search-modal");

  if (searchModal) {
    openSearchModal.addEventListener("click", function (e) {
      e.preventDefault();
      searchModal.classList.add("active");
      body.style.overflow = "hidden";
    });

    closeSearchModal.addEventListener("click", function (e) {
      e.preventDefault();
      searchModal.classList.remove("active");
      body.style.overflow = "auto";
    });
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("transition-overlay");

  if (!overlay) return;

  setTimeout(() => {
    const refreshBtn = overlay.querySelector(".refresh-link");
    if (!refreshBtn) return;

    refreshBtn.style.display = "none";

    refreshBtn.style.display = "inline-block";
    refreshBtn.addEventListener("click", () => {
      window.location.reload();
    });
  }, 5000); // 5s after transition overlay appears
});

// Donate Modal
document.addEventListener("DOMContentLoaded", function () {
  const modalDonate = document.querySelector(".donation-popup");

  if (!modalDonate) return;

  // Show modalDonate after 10 seconds
  setTimeout(() => {
    modalDonate.style.display = "flex";
  }, 10000);

  // Handle close buttons
  document
    .querySelector(".close-donation-popup")
    .addEventListener("click", function () {
      modalDonate.style.display = "none";
    });
});
